import type { IToastProps } from 'components/Toast';
import { State } from 'utils/state';

export interface IToastNotification extends IToastProps {
  show?: boolean;
  isBeingRendered?: boolean;
}

const defaults: Partial<IToastProps> = {
  linkText: '',
  message: '',
  title: '',
  newTab: false,
  timeout: 5000,
  to: '',
};

export const toastNotification = new State<IToastNotification>({ ...defaults, show: false, isBeingRendered: false });

let lastNotificationId: string | null = null;

export function showToast(toastProps: IToastProps) {
  // If this notification ID was just shown, don't show it again
  if (toastProps.notificationId && toastProps.notificationId === lastNotificationId) {
    return;
  }

  lastNotificationId = toastProps.notificationId || null;
  toastNotification.setValues({ ...defaults, ...toastProps, show: true });
}

export function resetToastState() {
  lastNotificationId = null;
  toastNotification.setValues({ show: false, isBeingRendered: false }, { reset: true });
}

export function claimToastRendering(): boolean {
  const currentState = toastNotification.get();
  if (currentState.show && !currentState.isBeingRendered) {
    toastNotification.setValues({ isBeingRendered: true });
    return true;
  }
  return false;
}

// Reset the last notification ID and rendering flag when the toast is hidden
toastNotification.on('change', (changedKeys, _changedValues, _oldValues, _values, currentState) => {
  if (changedKeys.includes('show') && currentState.show === false) {
    lastNotificationId = null;
    toastNotification.setValues({ isBeingRendered: false });
  }
});

export default toastNotification;
